import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import TicketsListItem from './TicketsListItem';
import TicketsDetails from './details/TicketsDetails';

import buttons from './TicketsButtons';
import events from './TicketsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('tickets'),
	routes: [
		{
			path: 'tickets/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'tickets'),
			element: (
				<DetailsPage
					key="tickets/add"
					module="tickets"
					tabs={TicketsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'tickets/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'tickets'),
			element: (
				<DetailsPage
					key="tickets/details"
					module="tickets"
					tabs={TicketsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'tickets/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'tickets'),
			element: (
				<ViewPage
					key="tickets/view"
					module="tickets"
					content={{ type: 'list', itemLayout: TicketsListItem, id: 'ticketsView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
